import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { Subscription } from 'rxjs';
import { SortOption } from '../../models/sortOption';
import { BaseODataService } from '../../services/base-odata.service';
import { CustomViewDisplayLayout } from '../odata-filter/models/custom-view-display-layout';

@Component({
  selector: 'app-paginator',
  templateUrl: './paginator.component.html',
  styleUrls: ['./paginator.component.scss'],
  standalone: false
})
export class PaginatorComponent implements OnInit, OnDestroy {
  customViewDisplayLayoutEnum = CustomViewDisplayLayout;
  resultCount: number;
  pageIndex = 0;
  subs: Subscription[] = [];

  @Input() customViewDisplayLayout: CustomViewDisplayLayout;
  @Input() currentSortOption: SortOption;
  @Input() sortOptions: SortOption[] = [];
  @Input() filterService: BaseODataService;
  @Output() sortChange = new EventEmitter<{ active: string; direction: string }>();
  @ViewChild(MatPaginator) paginator: MatPaginator;
  constructor() {}

  ngOnInit(): void {
    // filterResultValues does not replay, so a paginator created after the
    // results arrived (e.g. re-shown by a layout toggle) must seed the count
    // from the service's current state
    this.resultCount = this.filterService.totalResultCount;
    this.pageIndex = this.filterService.pageIndex;
    this.subs.push(
      this.filterService.filterResultValues.subscribe(() => {
        this.resultCount = this.filterService.totalResultCount;
        // the service can change page on its own (e.g. stepping back from an emptied page)
        this.pageIndex = this.filterService.pageIndex;
        if (this.paginator) {
          this.paginator.pageIndex = this.pageIndex;
        }
      }),
      this.filterService.appliedFilters.subscribe(() => {
        if (this.paginator) {
          this.paginator.pageIndex = 0;
        }
      })
    );
  }
  changeSort(sortOption: SortOption) {
    this.currentSortOption = sortOption;
    this.sortChange.emit({
      active: this.currentSortOption.property,
      direction: this.currentSortOption.orderType
    });
  }
  pageChanged(event: PageEvent) {
    if (event.previousPageIndex > event.pageIndex) {
      this.filterService.gotoPreviousPage();
    } else {
      this.filterService.gotoNextPage();
    }
  }
  ngOnDestroy(): void {
    this.subs.forEach((sub) => {
      sub.unsubscribe();
    });
  }
}
